import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabaseClient';
import { Shield, AlertTriangle } from 'lucide-react';

const LinkAccount: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleGoogleLink = async () => {
        setLoading(true);
        setError(null);
        try {
            const { error } = await supabase.auth.linkIdentity({
                provider: 'google',
                options: {
                    redirectTo: window.location.origin,
                }
            });
            if (error) throw error;
            // The browser will redirect to Google, so we may not reach here immediately
        } catch (err: any) {
            setError(err.message || 'An error occurred during account linking.');
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-[80vh] px-4">
            <div className="max-w-md w-full bg-zinc-900/50 border border-zinc-700 p-8 rounded-xl shadow-2xl backdrop-blur-sm">
                <div className="text-center mb-8">
                    <Shield className="w-12 h-12 text-tudor-gold mx-auto mb-4" />
                    <h1 className="text-2xl font-serif text-tudor-gold tracking-widest uppercase">
                        Secure Account
                    </h1>
                    <p className="text-zinc-500 text-sm mt-2">
                        Link your guest commission to a Google identity.
                    </p>
                </div>

                {error && (
                    <div className="bg-red-900/20 border border-red-500/50 p-3 mb-6 flex items-center gap-3 text-red-200 text-sm">
                        <AlertTriangle size={16} />
                        {error}
                    </div>
                )}

                <button
                    type="button"
                    onClick={handleGoogleLink}
                    disabled={loading}
                    className="w-full bg-white text-black font-bold py-3 rounded hover:bg-zinc-200 transition-colors uppercase tracking-widest flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <svg className="w-4 h-4" viewBox="0 0 24 24">
                        <path
                            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                            fill="#4285F4"
                        />
                        <path
                            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                            fill="#34A853"
                        />
                        <path
                            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                            fill="#FBBC05"
                        />
                        <path
                            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                            fill="#EA4335"
                        />
                    </svg>
                    {loading ? 'Linking...' : 'Link Google Account'}
                </button>

                <div className="mt-6 text-center text-xs text-zinc-500">
                    <button
                        onClick={() => navigate(-1)}
                        className="text-tudor-gold hover:underline uppercase tracking-wider font-bold"
                    >
                        Return to System
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LinkAccount;
